import { useTranslation } from 'react-i18next';

const NotFound = () => {
  const { t } = useTranslation();
  return <div>{t('Error.NotFound.Message')}</div>;
};

export default NotFound;
